<main class="container-wide">
  <div id="notfound">
    <div class="notfound">
      <div class="notfound-404">
        <h1 class="text--xl text--bold primary-500">404</h1>
      </div>
      <h2 class="text--lg text--bold primary-500">Oops! Une erreur est survenue</h2>
      <p class="gray-900">
        Désolé il semble que la page que vous chercher n'existe pas.<br />
        Cliquer ici pour retourner à l'accueil :<br />
        <a class="btn btn--primary btn--md" routerLink="/">Accueil</a>
      </p>
    </div>
  </div>
</main>
